import { Pipe, PipeTransform } from '@angular/core';
import { flightConformanceTypeList } from '@flyfreely-portal-ui/flyfreely';
import { setupStatusFormatter } from '../helpers';

@Pipe({ name: 'formatFlightConformanceType' })
export class FormatFlightConformanceTypePipe implements PipeTransform {
    transform: (value: any, ...args: any[]) => any;

    constructor() {
        this.transform = setupStatusFormatter(flightConformanceTypeList);
    }
}
